import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('billing');

export class Generatenc extends Api {
  constructor(http, config = {}) {
    super(http, url, 'generate-nc ', config);
  }
}